import colors from '../assets/colors.svg';

function Menu({ children }) {
    return (
        <div className='bg-black/35 border border-gray-400 rounded-md p-5 flex justify-center items-center flex-col w-[250px]'>
            <img src={colors} className='w-24 mt-8 mb-10' alt='Natuno' />
            { children }
        </div>
    )
}

export default Menu;